/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_AnonymisedInputs */

const cs_gdpr_anonymised = /** @type {(inputs: Gdpr_AnonymisedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osobní údaje byly anonymizovány.`)
};

const en_gdpr_anonymised = /** @type {(inputs: Gdpr_AnonymisedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal data anonymised.`)
};

/**
* | output |
* | --- |
* | "Personal data anonymised." |
*
* @param {Gdpr_AnonymisedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_anonymised = /** @type {((inputs?: Gdpr_AnonymisedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_AnonymisedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_anonymised(inputs)
	return cs_gdpr_anonymised(inputs)
});